module.exports = __webpack_public_path__ + "media/src/assets/images/img-regist-info-5d4538e4b5d93ea4730e202eaf188d4f.png";